const initialState = {
  showDisclaimer: false,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'SET_DISCLAIMER': {
      return {
        ...state,
        showDisclaimer: action.payload.show,
      }
    }
    default: {
      return state
    }
  }
}
